import { useContext, useEffect, useState } from "react";

import { Link, useLocation, useNavigate } from "react-router-dom";
import BucherLogo from "../../../common/components/svg/BucherLogo";
import "./Navbar.css";
import { CartContext } from "../../../utils/CartContext";
import { UserContext } from "../../../utils/UserContext";
import BreadCrumbs from "../../../common/components/breadcrumbs/BreadCrumbs";
import { Product } from "../../../utils/types";
import { CartItem } from "../../models/Cart";

function openInNewWindow(url: string): boolean {
  window.open(
    url,
    "newWindow",
    "width=1920,height=1080,scrollbars=yes,resizable=yes",
  );
  return false;
}

const Navbar = () => {
  const location = useLocation();
  const isLoggedIn = localStorage.getItem("loggedInUser");
  const [isActive, setIsActive] = useState(false);
  const [isActiveWatch, setIsActiveWatch] = useState(false);
  const [isActiveJewelery, setIsActiveJewelery] = useState(false);
  const [isActiveNovelty, setIsActiveNovelty] = useState(false);
  const [isActiveProfile, setisActiveProfile] = useState(false);
  const [username, setUsername] = useState(
    localStorage.getItem("loggedInUser"),
  );
  const { cart, cartDB, openCart  } = useContext(CartContext);
  const { user } = useContext(UserContext);
  const [showBanner, setShowBanner] = useState(
    () =>
      location.pathname === "/" &&
      sessionStorage.getItem("noticeDismissed") !== "true",
  );
  const [collapseBanner, setCollapseBanner] = useState(false);

  const handleCloseBanner = () => {
    setCollapseBanner(true);
    sessionStorage.setItem("noticeDismissed", "true");
    setTimeout(() => {
      setShowBanner(false);
    }, 500);
  };

  useEffect(() => {
    if (
      location.pathname === "/" &&
      sessionStorage.getItem("noticeDismissed") !== "true"
    ) {
      setCollapseBanner(false);
      setShowBanner(true);
    } else {
      setShowBanner(false);
    }
  }, [location.pathname, isLoggedIn]);

  const handleMenuClick = () => {
    setIsActive(!isActive);
    setIsActiveNovelty(false);
    setIsActiveJewelery(false);
    setIsActiveWatch(false);
    setisActiveProfile(false);
  };

  const handleMouseLeave = () => {
    setIsActiveNovelty(false);
    setIsActiveJewelery(false);
    setIsActiveWatch(false);
    setisActiveProfile(false);
  };

 /*  const handleMouseEnterJewelery = () => {
    setIsActiveWatch(false);
    setIsActiveJewelery(true);
    setIsActiveNovelty(false);
    setisActiveProfile(false);
  };

  const handleMouseEnterWatch = () => {
    setIsActiveWatch(true);
    setIsActiveJewelery(false);
    setIsActiveNovelty(false);
    setisActiveProfile(false);
  };

  const handleMouseEnterNovelty = () => {
    setIsActiveWatch(false);
    setIsActiveJewelery(false);
    setIsActiveNovelty(true);
    setisActiveProfile(false);
  }; */

  const handleMouseEnterProfile = () => {
    setIsActiveWatch(false);
    setIsActiveJewelery(false);
    setIsActiveNovelty(false);
    setisActiveProfile(true);
  };

  const handleMouseEnterButton = () => {
    setIsActiveWatch(false);
    setIsActiveJewelery(false);
    setIsActiveNovelty(false);
    setisActiveProfile(false);
  };
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("loggedInUser");
    setUsername(null);
    localStorage.removeItem("cart")
    navigate("/");
  };
  function NavBarOrderSVG() {
    return (
      <svg
        width="15"
        height="15"
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.30902 1C2.93025 1 2.58398 1.214 2.41459 1.55279L1.05279 4.27639C1.01807 4.34582 1 4.42238 1 4.5V13C1 13.5523 1.44772 14 2 14H13C13.5523 14 14 13.5523 14 13V4.5C14 4.42238 13.9819 4.34582 13.9472 4.27639L12.5854 1.55281C12.416 1.21403 12.0698 1.00003 11.691 1.00003L7.5 1.00001L3.30902 1ZM3.30902 2L7 2.00001V4H2.30902L3.30902 2ZM8 4V2.00002L11.691 2.00003L12.691 4H8ZM7.5 5H13V13H2V5H7.5ZM5.5 7C5.22386 7 5 7.22386 5 7.5C5 7.77614 5.22386 8 5.5 8H9.5C9.77614 8 10 7.77614 10 7.5C10 7.22386 9.77614 7 9.5 7H5.5Z"
          fill="currentColor"
          fillRule="evenodd"
          clipRule="evenodd"
        ></path>
      </svg>
    );
  }
  function NavBarOverviewSVG() {
    return (
      <svg
        width="15"
        height="15"
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.2 1H4.17741H4.1774C3.86936 0.999988 3.60368 0.999978 3.38609 1.02067C3.15576 1.04257 2.92825 1.09113 2.71625 1.22104C2.51442 1.34472 2.34473 1.51442 2.22104 1.71625C2.09113 1.92825 2.04257 2.15576 2.02067 2.38609C1.99998 2.60367 1.99999 2.86935 2 3.17738V3.1774V3.2V11.8V11.8226V11.8226C1.99999 12.1307 1.99998 12.3963 2.02067 12.6139C2.04257 12.8442 2.09113 13.0717 2.22104 13.2837C2.34473 13.4856 2.51442 13.6553 2.71625 13.779C2.92825 13.9089 3.15576 13.9574 3.38609 13.9793C3.60368 14 3.86937 14 4.17741 14H4.2H10.8H10.8226C11.1306 14 11.3963 14 11.6139 13.9793C11.8442 13.9574 12.0717 13.9089 12.2837 13.779C12.4856 13.6553 12.6553 13.4856 12.779 13.2837C12.9089 13.0717 12.9574 12.8442 12.9793 12.6139C13 12.3963 13 12.1306 13 11.8226V11.8V3.2V3.17741C13 2.86936 13 2.60368 12.9793 2.38609C12.9574 2.15576 12.9089 1.92825 12.779 1.71625C12.6553 1.51442 12.4856 1.34472 12.2837 1.22104C12.0717 1.09113 11.8442 1.04257 11.6139 1.02067C11.3963 0.999978 11.1306 0.999988 10.8226 1H10.8H4.2ZM3.23875 2.07368C3.26722 2.05623 3.32362 2.03112 3.48075 2.01618C3.64532 2.00053 3.86298 2 4.2 2H10.8C11.137 2 11.3547 2.00053 11.5193 2.01618C11.6764 2.03112 11.7328 2.05623 11.7613 2.07368C11.8285 2.11491 11.8851 2.17147 11.9263 2.23875C11.9438 2.26722 11.9689 2.32362 11.9838 2.48075C11.9995 2.64532 12 2.86298 12 3.2V11.8C12 12.137 11.9995 12.3547 11.9838 12.5193C11.9689 12.6764 11.9438 12.7328 11.9263 12.7613C11.8851 12.8285 11.8285 12.8851 11.7613 12.9263C11.7328 12.9438 11.6764 12.9689 11.5193 12.9838C11.3547 12.9995 11.137 13 10.8 13H4.2C3.86298 13 3.64532 12.9995 3.48075 12.9838C3.32362 12.9689 3.26722 12.9438 3.23875 12.9263C3.17147 12.8851 3.11491 12.8285 3.07368 12.7613C3.05624 12.7328 3.03112 12.6764 3.01618 12.5193C3.00053 12.3547 3 12.137 3 11.8V3.2C3 2.86298 3.00053 2.64532 3.01618 2.48075C3.03112 2.32362 3.05624 2.26722 3.07368 2.23875C3.11491 2.17147 3.17147 2.11491 3.23875 2.07368ZM5 10C4.72386 10 4.5 10.2239 4.5 10.5C4.5 10.7761 4.72386 11 5 11H8C8.27614 11 8.5 10.7761 8.5 10.5C8.5 10.2239 8.27614 10 8 10H5ZM4.5 7.5C4.5 7.22386 4.72386 7 5 7H10C10.2761 7 10.5 7.22386 10.5 7.5C10.5 7.77614 10.2761 8 10 8H5C4.72386 8 4.5 7.77614 4.5 7.5ZM5 4C4.72386 4 4.5 4.22386 4.5 4.5C4.5 4.77614 4.72386 5 5 5H10C10.2761 5 10.5 4.77614 10.5 4.5C10.5 4.22386 10.2761 4 10 4H5Z"
          fill="currentColor"
          fillRule="evenodd"
          clipRule="evenodd"
        ></path>
      </svg>
    );
  }
  function NavBarCartSVG() {
    return (
      <svg
        width="15"
        height="15"
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5 1C5 0.447715 5.44772 0 6 0H9C9.55228 0 10 0.447715 10 1V2H14C14.5523 2 15 2.44772 15 3V6C15 6.8888 14.6131 7.68734 14 8.23608V11.5C14 12.3284 13.3284 13 12.5 13H2.5C1.67157 13 1 12.3284 1 11.5V8.2359C0.38697 7.68721 0 6.88883 0 6V3C0 2.44772 0.447716 2 1 2H5V1ZM9 1V2H6V1H9ZM1 3H5H5.5H9.5H10H14V6C14 6.654 13.6866 7.23467 13.1997 7.6004C12.8655 7.85144 12.4508 8 12 8H8V7.5C8 7.22386 7.77614 7 7.5 7C7.22386 7 7 7.22386 7 7.5V8H3C2.5493 8 2.1346 7.85133 1.80029 7.60022C1.31335 7.23446 1 6.65396 1 6V3ZM7 9H3C2.64961 9 2.31292 8.93972 2 8.82905V11.5C2 11.7761 2.22386 12 2.5 12H12.5C12.7761 12 13 11.7761 13 11.5V8.82915C12.6871 8.93978 12.3504 9 12 9H8V9.5C8 9.77614 7.77614 10 7.5 10C7.22386 10 7 9.77614 7 9.5V9Z"
          fill="currentColor"
          fillRule="evenodd"
          clipRule="evenodd"
        ></path>
      </svg>
    );
  }
  function NavBarLogoutSVG() {
    return (
      <svg
        width="15"
        height="15"
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3 1C2.44771 1 2 1.44772 2 2V13C2 13.5523 2.44772 14 3 14H10.5C10.7761 14 11 13.7761 11 13.5C11 13.2239 10.7761 13 10.5 13H3V2L10.5 2C10.7761 2 11 1.77614 11 1.5C11 1.22386 10.7761 1 10.5 1H3ZM12.6036 4.89645C12.4083 4.70118 12.0917 4.70118 11.8964 4.89645C11.7012 5.09171 11.7012 5.40829 11.8964 5.60355L13.2929 7H6.5C6.22386 7 6 7.22386 6 7.5C6 7.77614 6.22386 8 6.5 8H13.2929L11.8964 9.39645C11.7012 9.59171 11.7012 9.90829 11.8964 10.1036C12.0917 10.2988 12.4083 10.2988 12.6036 10.1036L14.8536 7.85355C15.0488 7.65829 15.0488 7.34171 14.8536 7.14645L12.6036 4.89645Z"
          fill="currentColor"
          fillRule="evenodd"
          clipRule="evenodd"
        ></path>
      </svg>
    );
  }

  function calculateTotalItems(cartItems: CartItem[]) {
    return cartItems.reduce(
      (total: number, item: { quantity: number }) => total + item.quantity,
      0,
    );
  }
  const totalQuantity = username
    ? calculateTotalItems(cartDB.items || [])
    : calculateTotalItems(cart.items || []);
  const displayQuantity = totalQuantity >= 10 ? "9+" : totalQuantity.toString();

  return (
    <header className="header" onMouseLeave={handleMouseLeave}>
      <div className="container">
        <div
          className={`menu-container ${isActive ? "active" : ""}`}
          onClick={handleMenuClick}
        >
          <div className="line line-1">
            <div className="line-inner line-inner-1"></div>
          </div>
          <div className="line line-2">
            <div className="line-inner line-inner-2"></div>
          </div>
        </div>
        <div>
          <BucherLogo></BucherLogo>
        </div>
        <div className="centerMenu">
          <Link
            /* className={`watches-container text-xs text-gray-50 lg:text-sm ${
              isActiveWatch ? "active" : ""
            }`}
            onMouseMove={handleMouseEnterWatch} */
            className="text-xs text-gray-50 lg:text-sm"
            to={"/UHREN"}
          >
            Uhren
          </Link>
          <Link
            /* className={`jewelery-container text-xs text-gray-50 lg:text-sm ${
              isActiveJewelery ? "active" : ""
            }`}
            onMouseMove={handleMouseEnterJewelery} */
            className="text-xs text-gray-50 lg:text-sm"
            to={"/SCHMUCK"}
          >
            Schmuck
          </Link>
          <Link
            /* className={`novelty-container text-xs text-gray-50 lg:text-sm ${
              isActiveNovelty ? "active" : ""
            }`}
            onMouseMove={handleMouseEnterNovelty} */
            className="text-xs text-gray-50 lg:text-sm"
            to={"/THOMAS-SABO"}
          >
            Thomas Sabo
          </Link>
          <a
            className="border-sidebarGray-400 bg-sidebarGray-700 hover:bg-sidebarGray-500 flex items-center justify-center gap-2 rounded-full border-[1px] px-4 py-1 text-xs text-gray-50 lg:text-sm"
            href="https://konfigurator.breuning.de/public/5cd159e92bc9fc000c83a331/home"
            onMouseMove={handleMouseEnterButton}
            onClick={(e) => {
              e.preventDefault();
              openInNewWindow(
                "https://konfigurator.breuning.de/public/5cd159e92bc9fc000c83a331/home",
              );
            }}
          >
            Trauringe konfigurieren
            <svg
              width="15"
              height="15"
              viewBox="0 0 15 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 13C12.5523 13 13 12.5523 13 12V3C13 2.44771 12.5523 2 12 2H3C2.44771 2 2 2.44771 2 3V6.5C2 6.77614 2.22386 7 2.5 7C2.77614 7 3 6.77614 3 6.5V3H12V12H8.5C8.22386 12 8 12.2239 8 12.5C8 12.7761 8.22386 13 8.5 13H12ZM9 6.5C9 6.5001 9 6.50021 9 6.50031V6.50035V9.5C9 9.77614 8.77614 10 8.5 10C8.22386 10 8 9.77614 8 9.5V7.70711L2.85355 12.8536C2.65829 13.0488 2.34171 13.0488 2.14645 12.8536C1.95118 12.6583 1.95118 12.3417 2.14645 12.1464L7.29289 7H5.5C5.22386 7 5 6.77614 5 6.5C5 6.22386 5.22386 6 5.5 6H8.5C8.56779 6 8.63244 6.01349 8.69139 6.03794C8.74949 6.06198 8.80398 6.09744 8.85143 6.14433C8.94251 6.23434 8.9992 6.35909 8.99999 6.49708L8.99999 6.49738"
                fill="currentColor"
              ></path>
            </svg>
          </a>
        </div>
        <div className="util-container flex items-center justify-end">
          {isLoggedIn ? (
            <button
              style={{ border: "none" }}
              className="relative rounded-lg p-4 text-gray-50"
              onClick={openCart}
            >
              <svg
                width="25"
                height="25"
                viewBox="0 0 15 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5 1C5 0.447715 5.44772 0 6 0H9C9.55228 0 10 0.447715 10 1V2H14C14.5523 2 15 2.44772 15 3V6C15 6.8888 14.6131 7.68734 14 8.23608V11.5C14 12.3284 13.3284 13 12.5 13H2.5C1.67157 13 1 12.3284 1 11.5V8.2359C0.38697 7.68721 0 6.88883 0 6V3C0 2.44772 0.447716 2 1 2H5V1ZM9 1V2H6V1H9ZM1 3H5H5.5H9.5H10H14V6C14 6.654 13.6866 7.23467 13.1997 7.6004C12.8655 7.85144 12.4508 8 12 8H8V7.5C8 7.22386 7.77614 7 7.5 7C7.22386 7 7 7.22386 7 7.5V8H3C2.5493 8 2.1346 7.85133 1.80029 7.60022C1.31335 7.23446 1 6.65396 1 6V3ZM7 9H3C2.64961 9 2.31292 8.93972 2 8.82905V11.5C2 11.7761 2.22386 12 2.5 12H12.5C12.7761 12 13 11.7761 13 11.5V8.82915C12.6871 8.93978 12.3504 9 12 9H8V9.5C8 9.77614 7.77614 10 7.5 10C7.22386 10 7 9.77614 7 9.5V9Z"
                  fill="currentColor"
                  fillRule="evenodd"
                  clipRule="evenodd"
                ></path>
              </svg>
              {totalQuantity === 0 && <></>}
              {totalQuantity > 0 && (
                <div className="absolute right-2 top-2 flex h-5 w-5 items-center justify-center rounded-full bg-gray-50">
                  <span className="text-md m-0 rounded-full p-0 text-center text-gray-950">
                    {displayQuantity}
                  </span>
                </div>
              )}
            </button>
          ) : (
            <button
              style={{ border: "none" }}
              className="relative rounded-lg p-4 text-gray-50"
              onClick={openCart}
            >
              <svg
                width="25"
                height="25"
                viewBox="0 0 15 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5 1C5 0.447715 5.44772 0 6 0H9C9.55228 0 10 0.447715 10 1V2H14C14.5523 2 15 2.44772 15 3V6C15 6.8888 14.6131 7.68734 14 8.23608V11.5C14 12.3284 13.3284 13 12.5 13H2.5C1.67157 13 1 12.3284 1 11.5V8.2359C0.38697 7.68721 0 6.88883 0 6V3C0 2.44772 0.447716 2 1 2H5V1ZM9 1V2H6V1H9ZM1 3H5H5.5H9.5H10H14V6C14 6.654 13.6866 7.23467 13.1997 7.6004C12.8655 7.85144 12.4508 8 12 8H8V7.5C8 7.22386 7.77614 7 7.5 7C7.22386 7 7 7.22386 7 7.5V8H3C2.5493 8 2.1346 7.85133 1.80029 7.60022C1.31335 7.23446 1 6.65396 1 6V3ZM7 9H3C2.64961 9 2.31292 8.93972 2 8.82905V11.5C2 11.7761 2.22386 12 2.5 12H12.5C12.7761 12 13 11.7761 13 11.5V8.82915C12.6871 8.93978 12.3504 9 12 9H8V9.5C8 9.77614 7.77614 10 7.5 10C7.22386 10 7 9.77614 7 9.5V9Z"
                  fill="currentColor"
                  fillRule="evenodd"
                  clipRule="evenodd"
                ></path>
              </svg>
              {totalQuantity === 0 && <></>}
              {totalQuantity > 0 && (
                <div className="absolute right-2 top-2 flex h-5 w-5 items-center justify-center rounded-full bg-gray-50">
                  <span className="text-md m-0 rounded-full p-0 text-center text-gray-950">
                    {displayQuantity}
                  </span>
                </div>
              )}
            </button>
          )}
          {user ? (
            <button
              className={`profile-container rounded-lg p-2 ${
                isActiveProfile ? "active" : ""
              }`}
              onClick={handleMouseEnterProfile}
            >
              <div className="flex items-center justify-center text-gray-50">
                <svg
                  width="25"
                  height="25"
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.5 0.875C5.49797 0.875 3.875 2.49797 3.875 4.5C3.875 6.15288 4.98124 7.54738 6.49373 7.98351C5.2997 8.12901 4.27557 8.55134 3.50407 9.31167C2.52216 10.2794 2.02502 11.72 2.02502 13.5999C2.02502 13.8623 2.23769 14.0749 2.50002 14.0749C2.76236 14.0749 2.97502 13.8623 2.97502 13.5999C2.97502 11.8799 3.42786 10.7206 4.17091 9.9883C4.91536 9.25463 6.02674 8.87499 7.49995 8.87499C8.97317 8.87499 10.0846 9.25463 10.8291 9.98831C11.5721 10.7206 12.025 11.8799 12.025 13.5999C12.025 13.8623 12.2376 14.0749 12.5 14.0749C12.7623 14.075 12.975 13.8623 12.975 13.6C12.975 11.72 12.4778 10.2794 11.4959 9.31166C10.7244 8.55135 9.70025 8.12903 8.50625 7.98352C10.0187 7.5474 11.125 6.15289 11.125 4.5C11.125 2.49797 9.50203 0.875 7.5 0.875ZM4.825 4.5C4.825 3.02264 6.02264 1.825 7.5 1.825C8.97736 1.825 10.175 3.02264 10.175 4.5C10.175 5.97736 8.97736 7.175 7.5 7.175C6.02264 7.175 4.825 5.97736 4.825 4.5Z"
                    fill="#fff"
                    fillRule="evenodd"
                    clipRule="evenodd"
                  ></path>
                </svg>
              </div>
            </button>
          ) : (
            <button
              className={`profile-container w-auto rounded-lg p-2 ${
                isActiveProfile ? "active" : ""
              }`}
              onClick={handleMouseEnterProfile}
            >
              <svg
                width="25"
                height="25"
                viewBox="0 0 15 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.5 0.875C5.49797 0.875 3.875 2.49797 3.875 4.5C3.875 6.15288 4.98124 7.54738 6.49373 7.98351C5.2997 8.12901 4.27557 8.55134 3.50407 9.31167C2.52216 10.2794 2.02502 11.72 2.02502 13.5999C2.02502 13.8623 2.23769 14.0749 2.50002 14.0749C2.76236 14.0749 2.97502 13.8623 2.97502 13.5999C2.97502 11.8799 3.42786 10.7206 4.17091 9.9883C4.91536 9.25463 6.02674 8.87499 7.49995 8.87499C8.97317 8.87499 10.0846 9.25463 10.8291 9.98831C11.5721 10.7206 12.025 11.8799 12.025 13.5999C12.025 13.8623 12.2376 14.0749 12.5 14.0749C12.7623 14.075 12.975 13.8623 12.975 13.6C12.975 11.72 12.4778 10.2794 11.4959 9.31166C10.7244 8.55135 9.70025 8.12903 8.50625 7.98352C10.0187 7.5474 11.125 6.15289 11.125 4.5C11.125 2.49797 9.50203 0.875 7.5 0.875ZM4.825 4.5C4.825 3.02264 6.02264 1.825 7.5 1.825C8.97736 1.825 10.175 3.02264 10.175 4.5C10.175 5.97736 8.97736 7.175 7.5 7.175C6.02264 7.175 4.825 5.97736 4.825 4.5Z"
                  fill="#fff"
                  fillRule="evenodd"
                  clipRule="evenodd"
                ></path>
              </svg>
            </button>
          )}
        </div>
      </div>
      {showBanner && (
        <div
          id="sticky-banner"
          tabIndex={-1}
          className={`fixed top-[65px] start-0 z-50 w-full p-4 pe-14 ps-14 border-b border-gray-200 bg-gray-50 dark:bg-gray-700 dark:border-gray-600 bg-gradient-to-r from-blue-600 to-gray-400 ${
            collapseBanner ? "banner-collapse" : "banner-expand"
          }`}
        >
          <div className="flex items-center justify-center">
            <p className="flex items-center text-sm font-normal text-gray-500 dark:text-gray-400">
              <span className="inline-flex p-1 me-3 bg-gray-200 rounded-full dark:bg-gray-600 w-6 h-6 items-center justify-center flex-shrink-0">
                <svg
                  className="w-3 h-3 text-gray-500 dark:text-gray-400"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z" />
                </svg>
                <span className="sr-only">Hinweis</span>
              </span>
              <span className="text-sm lg:text-lg text-white text-center">
                Liebe Kundinnen und Kunden, leider wird unser Name derzeit von
                einer fremden Webseite für Betrugsversuche verwendet. Unser
                einziger Onlineshop ist{" "}
                <span className="font-serif">juwelier-bucher.de</span>. Hier
                sind Sie richtig.
              </span>
            </p>
          </div>
          <button
            type="button"
            className="absolute end-4 top-1/2 -translate-y-1/2 flex-shrink-0 inline-flex justify-center w-7 h-7 items-center text-white hover:bg-white/20 rounded-lg text-sm p-1.5"
            onClick={handleCloseBanner}
          >
            <svg
              className="w-4 h-4"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 14 14"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
              />
            </svg>
            <span className="sr-only">Hinweis schließen</span>
          </button>
        </div>
      )}
      <div
        className={`menu-watches-container text-lg ${
          isActiveWatch ? "active" : ""
        }`}
      >
        <ul>
          <li className={`mc-li-1 ${isActiveWatch ? "active" : ""}`}>
            <Link to={"/UHREN"}>Armbanduhren</Link>
          </li>

          <li className={`mc-li-2 ${isActiveWatch ? "active" : ""}`}>
            <Link to={"/UHREN"}>Standuhren</Link>
          </li>

          <li className={`mc-li-3 ${isActiveWatch ? "active" : ""}`}>
            <Link to={"/UHREN?productFamily=Wecker"}>Wecker</Link>
          </li>
          <li className={`mc-li-4 ${isActiveWatch ? "active" : ""}`}>
            <div className="ringsConfig-container border-sidebarGray-500 border-t-[1px] pt-4">
              <h3>
                Konfigurieren&nbsp;Sie&nbsp;ihre&nbsp;eigenen&nbsp;Trauringe
              </h3>
              <a
                href="https://konfigurator.breuning.de/public/5cd159e92bc9fc000c83a331/home"
                onClick={(e) => {
                  e.preventDefault();
                  openInNewWindow(
                    "https://konfigurator.breuning.de/public/5cd159e92bc9fc000c83a331/home",
                  );
                }}
              >
                Trauringe konfigurieren
                <svg
                  width="15"
                  height="15"
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 13C12.5523 13 13 12.5523 13 12V3C13 2.44771 12.5523 2 12 2H3C2.44771 2 2 2.44771 2 3V6.5C2 6.77614 2.22386 7 2.5 7C2.77614 7 3 6.77614 3 6.5V3H12V12H8.5C8.22386 12 8 12.2239 8 12.5C8 12.7761 8.22386 13 8.5 13H12ZM9 6.5C9 6.5001 9 6.50021 9 6.50031V6.50035V9.5C9 9.77614 8.77614 10 8.5 10C8.22386 10 8 9.77614 8 9.5V7.70711L2.85355 12.8536C2.65829 13.0488 2.34171 13.0488 2.14645 12.8536C1.95118 12.6583 1.95118 12.3417 2.14645 12.1464L7.29289 7H5.5C5.22386 7 5 6.77614 5 6.5C5 6.22386 5.22386 6 5.5 6H8.5C8.56779 6 8.63244 6.01349 8.69139 6.03794C8.74949 6.06198 8.80398 6.09744 8.85143 6.14433C8.94251 6.23434 8.9992 6.35909 8.99999 6.49708L8.99999 6.49738"
                    fill="currentColor"
                  ></path>
                </svg>
              </a>
            </div>
          </li>
        </ul>
      </div>
      <div
        className={`menu-jewelery-container text-lg ${
          isActiveJewelery ? "active" : ""
        }`}
      >
        <ul>
          <li className={`mc-li-1 ${isActiveJewelery ? "active" : ""}`}>
            <Link to={"/shop/watches"}>Ringe</Link>
          </li>

          <li className={`mc-li-2 ${isActiveJewelery ? "active" : ""}`}>
            <Link to={"/shop/watches"}>Ohrstecker</Link>
          </li>

          <li className={`mc-li-3 ${isActiveJewelery ? "active" : ""}`}>
            <Link to={"/shop/novelty"}>Halsketten</Link>
          </li>
          <li className={`mc-li-4 ${isActiveJewelery ? "active" : ""}`}>
            <Link to={"/shop/novelty"}>Anhänger</Link>
          </li>
          <li className={`mc-li-5 ${isActiveJewelery ? "active" : ""}`}>
            <Link to={"/shop/novelty"}>Goldschmuck</Link>
          </li>
          <li className={`mc-li-6 ${isActiveJewelery ? "active" : ""}`}>
            <div className="ringsConfig-container border-sidebarGray-500 border-t-[1px] pt-4">
              <h3>
                Konfigurieren&nbsp;Sie&nbsp;ihre&nbsp;eigenen&nbsp;Trauringe
              </h3>
              <a
                href="https://konfigurator.breuning.de/public/5cd159e92bc9fc000c83a331/home"
                onClick={(e) => {
                  e.preventDefault();
                  openInNewWindow(
                    "https://konfigurator.breuning.de/public/5cd159e92bc9fc000c83a331/home",
                  );
                }}
              >
                Trauringe konfigurieren
                <svg
                  width="15"
                  height="15"
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 13C12.5523 13 13 12.5523 13 12V3C13 2.44771 12.5523 2 12 2H3C2.44771 2 2 2.44771 2 3V6.5C2 6.77614 2.22386 7 2.5 7C2.77614 7 3 6.77614 3 6.5V3H12V12H8.5C8.22386 12 8 12.2239 8 12.5C8 12.7761 8.22386 13 8.5 13H12ZM9 6.5C9 6.5001 9 6.50021 9 6.50031V6.50035V9.5C9 9.77614 8.77614 10 8.5 10C8.22386 10 8 9.77614 8 9.5V7.70711L2.85355 12.8536C2.65829 13.0488 2.34171 13.0488 2.14645 12.8536C1.95118 12.6583 1.95118 12.3417 2.14645 12.1464L7.29289 7H5.5C5.22386 7 5 6.77614 5 6.5C5 6.22386 5.22386 6 5.5 6H8.5C8.56779 6 8.63244 6.01349 8.69139 6.03794C8.74949 6.06198 8.80398 6.09744 8.85143 6.14433C8.94251 6.23434 8.9992 6.35909 8.99999 6.49708L8.99999 6.49738"
                    fill="currentColor"
                  ></path>
                </svg>
              </a>
            </div>
          </li>
        </ul>
      </div>
      <div
        className={`menu-novelty-container text-lg ${
          isActiveNovelty ? "active" : ""
        }`}
      >
        <ul>
          <li className={`mc-li-1 ${isActiveNovelty ? "active" : ""}`}>
            <Link to={"/shop/watches"}>Ringe</Link>
          </li>

          <li className={`mc-li-2 ${isActiveNovelty ? "active" : ""}`}>
            <Link to={"/shop/watches"}>Halsketten</Link>
          </li>

          <li className={`mc-li-3 ${isActiveNovelty ? "active" : ""}`}>
            <Link to={"/shop/novelty"}>Armbänder</Link>
          </li>

          <li className={`mc-li-4 ${isActiveNovelty ? "active" : ""}`}>
            <Link to={"/shop/novelty"}>Beads</Link>
          </li>

          <li className={`mc-li-5 ${isActiveNovelty ? "active" : ""}`}>
            <Link to={"/shop/novelty"}>Anhänger</Link>
          </li>
          <li className={`mc-li-6 ${isActiveNovelty ? "active" : ""}`}>
            <div className="ringsConfig-container border-sidebarGray-500 border-t-[1px] pt-4">
              <h3>
                Konfigurieren&nbsp;Sie&nbsp;ihre&nbsp;eigenen&nbsp;Trauringe
              </h3>
              <a
                href="https://konfigurator.breuning.de/public/5cd159e92bc9fc000c83a331/home"
                onClick={(e) => {
                  e.preventDefault();
                  openInNewWindow(
                    "https://konfigurator.breuning.de/public/5cd159e92bc9fc000c83a331/home",
                  );
                }}
              >
                Trauringe konfigurieren
                <svg
                  width="15"
                  height="15"
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 13C12.5523 13 13 12.5523 13 12V3C13 2.44771 12.5523 2 12 2H3C2.44771 2 2 2.44771 2 3V6.5C2 6.77614 2.22386 7 2.5 7C2.77614 7 3 6.77614 3 6.5V3H12V12H8.5C8.22386 12 8 12.2239 8 12.5C8 12.7761 8.22386 13 8.5 13H12ZM9 6.5C9 6.5001 9 6.50021 9 6.50031V6.50035V9.5C9 9.77614 8.77614 10 8.5 10C8.22386 10 8 9.77614 8 9.5V7.70711L2.85355 12.8536C2.65829 13.0488 2.34171 13.0488 2.14645 12.8536C1.95118 12.6583 1.95118 12.3417 2.14645 12.1464L7.29289 7H5.5C5.22386 7 5 6.77614 5 6.5C5 6.22386 5.22386 6 5.5 6H8.5C8.56779 6 8.63244 6.01349 8.69139 6.03794C8.74949 6.06198 8.80398 6.09744 8.85143 6.14433C8.94251 6.23434 8.9992 6.35909 8.99999 6.49708L8.99999 6.49738"
                    fill="currentColor"
                  ></path>
                </svg>
              </a>
            </div>
          </li>
        </ul>
      </div>
      <div
        className={`menu-profile-container text-lg ${
          isActiveProfile ? "active" : ""
        }`}
      >
        <ul>
          <li className={`mc-li-1 ${isActiveProfile ? "active" : ""}`}>
            {isLoggedIn && (
              <h1 className="text-medium text-lg text-gray-50">
                <span className="text-sidebarGray-400 text-sm">Ihr Konto</span>
                &nbsp;&nbsp;&nbsp;{user?.firstName}
              </h1>
            )}
            <hr className="border-sidebarGray-700 my-4" />
          </li>
          {isLoggedIn ? (
            <>
              <li className={`mc-li-2 ${isActiveProfile ? "active" : ""}`}>
                <Link to={"/user"}>
                  <NavBarOverviewSVG />
                  Kontoübersicht
                </Link>
              </li>
              <li className={`mc-li-3 ${isActiveProfile ? "active" : ""}`}>
                <Link to={"/user/Bestellungen"}>
                  <NavBarOrderSVG />
                  Meine Bestellungen
                </Link>
              </li>
              {/* <li className={`mc-li-4 ${isActiveProfile ? 'active' : ''}`}>
                                <Link to={'/user/settings'}>Einstellungen</Link>
                            </li> */}
              <li className={`mc-li-4 ${isActiveProfile ? "active" : ""}`}>
                <Link to={"/"} onClick={handleLogout}>
                  <NavBarLogoutSVG />
                  Ausloggen
                </Link>
              </li>
            </>
          ) : (
            <li className={`mc-li-2 ${isActiveProfile ? "active" : ""}`}>
              <Link to={"/sign-in"}>
                <button className="flex w-max items-center justify-center gap-4 rounded-lg border-2 border-gray-50 px-6 py-2 text-base hover:bg-gray-50 hover:text-gray-900">
                  <svg
                    width="15"
                    height="15"
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.5 1C4.22386 1 4 1.22386 4 1.5C4 1.77614 4.22386 2 4.5 2H12V13H4.5C4.22386 13 4 13.2239 4 13.5C4 13.7761 4.22386 14 4.5 14H12C12.5523 14 13 13.5523 13 13V2C13 1.44772 12.5523 1 12 1H4.5ZM6.60355 4.89645C6.40829 4.70118 6.09171 4.70118 5.89645 4.89645C5.70118 5.09171 5.70118 5.40829 5.89645 5.60355L7.29289 7H0.5C0.223858 7 0 7.22386 0 7.5C0 7.77614 0.223858 8 0.5 8H7.29289L5.89645 9.39645C5.70118 9.59171 5.70118 9.90829 5.89645 10.1036C6.09171 10.2988 6.40829 10.2988 6.60355 10.1036L8.85355 7.85355C9.04882 7.65829 9.04882 7.34171 8.85355 7.14645L6.60355 4.89645Z"
                      fill="currentColor"
                      fillRule="evenodd"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                  Anmelden
                </button>
              </Link>
            </li>
          )}
        </ul>
      </div>
      <div className={`menu-items-container ${isActive ? "active" : ""}`}>
        <ul>
          <h3 className="text-neutral-400 text-sm">UNSER ANGEBOT</h3>
          <li className={`mc-li-1 ${isActive ? "active" : ""}`}>
            <Link to={"/UHREN"}>Uhren</Link>
          </li>
          <li className={`mc-li-2 ${isActive ? "active" : ""}`}>
            <Link to={"/SCHMUCK"}>Schmuck</Link>
          </li>
          <li className={`mc-li-3 ${isActive ? "active" : ""}`}>
            <Link to={"/THOMAS-SABO"}>Thomas Sabo</Link>
          </li>
          <li className={`mc-li-5 ${isActive ? "active" : ""}`}>
            <div className="ringsConfig-container border-slate-700">
              <a
                href="https://konfigurator.breuning.de/public/5cd159e92bc9fc000c83a331/home"
                onClick={(e) => {
                  e.preventDefault();
                  openInNewWindow(
                    "https://konfigurator.breuning.de/public/5cd159e92bc9fc000c83a331/home",
                  );
                }}
                className="border-sidebarGray-700 w-max rounded-md border-[1px] px-4 py-1"
              >
                Trauringe konfigurieren
                <svg
                  width="15"
                  height="15"
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 13C12.5523 13 13 12.5523 13 12V3C13 2.44771 12.5523 2 12 2H3C2.44771 2 2 2.44771 2 3V6.5C2 6.77614 2.22386 7 2.5 7C2.77614 7 3 6.77614 3 6.5V3H12V12H8.5C8.22386 12 8 12.2239 8 12.5C8 12.7761 8.22386 13 8.5 13H12ZM9 6.5C9 6.5001 9 6.50021 9 6.50031V6.50035V9.5C9 9.77614 8.77614 10 8.5 10C8.22386 10 8 9.77614 8 9.5V7.70711L2.85355 12.8536C2.65829 13.0488 2.34171 13.0488 2.14645 12.8536C1.95118 12.6583 1.95118 12.3417 2.14645 12.1464L7.29289 7H5.5C5.22386 7 5 6.77614 5 6.5C5 6.22386 5.22386 6 5.5 6H8.5C8.56779 6 8.63244 6.01349 8.69139 6.03794C8.74949 6.06198 8.80398 6.09744 8.85143 6.14433C8.94251 6.23434 8.9992 6.35909 8.99999 6.49708L8.99999 6.49738"
                    fill="currentColor"
                  ></path>
                </svg>
              </a>
            </div>
          </li>
          <hr className="bg-sidebarGray-700 my-4" />
          {username ? (
            <>
              <h1 className="flex w-full flex-row items-center justify-center gap-4 text-lg text-gray-50">
                <span className="text-sidebarGray-400 text-xs">Ihr Konto</span>
                <p>{user?.firstName}</p>
              </h1>
              <li className={`mc-li-7 ${isActive ? "active" : ""}`}>
                <Link to={"/user"}>
                  <NavBarOverviewSVG />
                  Kontoübersicht
                </Link>
              </li>
              <li className={`mc-li-8 ${isActive ? "active" : ""}`}>
                <Link to={"/user/Bestellungen"}>
                  <NavBarOrderSVG />
                  Bestellungen
                </Link>
              </li>
              {/* <li className={`mc-li-9 ${isActive ? 'active' : ''}`}>
                                <Link to={'/user/settings'}>Einstellungen</Link>
                            </li> */}
              <li className={`mc-li-10 ${isActive ? "active" : ""}`}>
                <Link to={"/"} onClick={handleLogout}>
                  <NavBarLogoutSVG />
                  Ausloggen
                </Link>
              </li>
            </>
          ) : (
            <li className={`mc-li-7 ${isActive ? "active" : ""}`}>
              <Link to={"/sign-in"}>
                <button className="flex w-full items-center justify-center gap-4 rounded-lg border-2 border-gray-50 px-6 py-2 text-base hover:bg-gray-50 hover:text-gray-900">
                  Anmelden
                </button>
              </Link>
            </li>
          )}
        </ul>
      </div>
      <BreadCrumbs />
    </header>
  );
};

export default Navbar;
